import BreadCum from "../BreadCum"

const Header = ({ firstLevel, secondLevel, middleLevel }) => {
  return (
    <BreadCum firstLevel={firstLevel} secondLevel={secondLevel} middleLevel={middleLevel} />
  )
}

export default Header